define(["require", "exports", "tslib"], function (require, exports, tslib_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.printLoggedRequests = exports.enableRequestLogging = void 0;
    const originalFetch = window.fetch;
    const exclusions = ["google-analytics.com", "js.arcgis.com"];
    const requestCache = new Set();
    function enableRequestLogging(enableLogging) {
        if (enableLogging) {
            window.fetch = (input, init) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const method = (init === null || init === void 0 ? void 0 : init.method) || 'GET';
                const url = typeof input === 'string' ? input : input.url;
                const headers = (init === null || init === void 0 ? void 0 : init.headers) || {};
                const body = (init === null || init === void 0 ? void 0 : init.body) || '';
                if (exclusions.every(exclusion => !url.includes(exclusion))) {
                    let curlCommand = `curl -X ${method} '${url}'`;
                    if (headers && typeof headers === 'object') {
                        for (const [key, value] of Object.entries(headers)) {
                            curlCommand += ` -H '${key}: ${value}'`;
                        }
                    }
                    if (body && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
                        curlCommand += ` -d '${body}'`;
                    }
                    requestCache.add(curlCommand);
                }
                return originalFetch(input, init);
            });
        }
        else {
            window.fetch = originalFetch;
        }
    }
    exports.enableRequestLogging = enableRequestLogging;
    function printLoggedRequests() {
        console.log([...requestCache].join('\n\n'));
    }
    exports.printLoggedRequests = printLoggedRequests;
});
